import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Home, ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

/**
 * NotFoundPage - Fun 404 error page
 * "Sold Too Fast" theme - marketplace humor
 */
const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      
      <div className="flex-1 flex items-center justify-center px-4 py-12 bg-gradient-to-b from-slate-900 to-slate-950">
        <div className="text-center max-w-lg mx-auto">
          {/* Emoji Animation */}
          <div className="text-7xl sm:text-8xl mb-6 animate-bounce">
            🏃‍♂️💨
          </div>
          
          {/* 404 Code */}
          <h1 className="text-8xl sm:text-9xl font-black text-primary leading-none mb-4">
            404
          </h1>
          
          {/* Title */}
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">
            This page sold faster than you clicked!
          </h2>
          
          {/* Message */}
          <p className="text-slate-400 text-base sm:text-lg mb-8 leading-relaxed">
            Looks like someone snagged this deal before you got here.
            <br />
            Don't worry, we've got plenty more treasures.
          </p>
          
          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/marketplace"
              className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white px-6 py-3.5 rounded-xl font-semibold text-base transition-all hover:scale-105 shadow-lg shadow-primary/25"
              data-testid="404-browse-btn"
            >
              <Search className="w-5 h-5" />
              Browse Listings
            </Link>
            
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-primary text-primary hover:bg-primary/10 px-6 py-3.5 rounded-xl font-semibold text-base transition-all"
              data-testid="404-home-btn"
            >
              <Home className="w-5 h-5" />
              Go Home
            </Link>
          </div>
          
          {/* Back button */}
          <button
            onClick={() => window.history.back()}
            className="mt-8 inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-300 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Go back to previous page
          </button>
          
          {/* Fun footer text */}
          <p className="text-slate-600 text-xs mt-8">
            Error 404 • Page not found • But your next deal awaits!
          </p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NotFoundPage;
